var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"pb-2"},[_c('e-commerce-product-details',{on:{"update:grade":_vm.updatedGrade,"calcular-imposto":_vm.calcularImposto,"remove-item":_vm.handleRemoveItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }